var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWetlands = function SvgWetlands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4BCEEB",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M39.613 25.9a37.3 37.3 0 0 1-6.363-12.025 1.25 1.25 0 0 0-1.25-.9 1.25 1.25 0 0 0-1.25.9A37.301 37.301 0 0 1 24.338 25.9c-2.625 3.625-4.888 6.762-4.888 11.1a12.5 12.5 0 0 0 25 0c.05-4.275-2.212-7.475-4.837-11.1zM32 47a10 10 0 0 1-10-10c0-3.525 1.95-6.25 4.413-9.638A44.539 44.539 0 0 0 32 18a44.539 44.539 0 0 0 5.588 9.362C40.088 30.775 42 33.475 42 37a10 10 0 0 1-10 10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M31 41.9a5 5 0 0 1-4-4.913 1.25 1.25 0 0 0-2.5 0 7.5 7.5 0 0 0 6 7.363h.25a1.25 1.25 0 0 0 1.25-1 1.25 1.25 0 0 0-1-1.45z"
  })));
};
export default SvgWetlands;